import React from "react";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import {
    formatDateTimeValue,
    formatDateValue,
    parseDateTimeValue,
    parseDateValue,
    resolveDatepickerLocale,
} from "./utils";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";

interface DateInputProps {
    className?: string;
    title: string;
    placeholder?: string;
    value: string;
    onChange(val: string): void;
    error?: boolean;
    disabled?: boolean;
    required?: boolean;
    type?: "date" | "datetime-local";
}

const DateInput: React.FC<DateInputProps> = ({
    onChange,
    title,
    value,
    required = false,
    className = "",
    disabled = false,
    error = false,
    placeholder,
    type = "date",
}) => {
    const [isFocused, setIsFocused] = React.useState<boolean>(false);
    const { i18n } = useTranslation();
    const isDateTime = type === "datetime-local";
    const locale = resolveDatepickerLocale(i18n.resolvedLanguage || i18n.language || "en");
    const selectedDate = isDateTime ? parseDateTimeValue(value) : parseDateValue(value);

    return (
        <div
            className={classNames(`date-input ${className}`, {
                "date-input--focused": isFocused,
                "date-input--error": error,
            })}
        >
            {title && (
                <div className="date-input__title">
                    {title}
                    {required && <span className="date-input__required">*</span>}
                </div>
            )}
            <div className="date-input__wrap">
                <DatePicker
                    className="date-input__field"
                    calendarClassName="date-input__calendar"
                    popperClassName="date-input__popper"
                    popperPlacement="bottom-start"
                    selected={selectedDate}
                    onChange={(date: Date | null) =>
                        onChange(date ? (isDateTime ? formatDateTimeValue(date) : formatDateValue(date)) : "")
                    }
                    dateFormat={isDateTime ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
                    showTimeSelect={isDateTime}
                    timeIntervals={10}
                    timeFormat="HH:mm"
                    placeholderText={placeholder}
                    locale={locale}
                    disabled={disabled}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />
                <div className="date-input__icon"></div>
            </div>
        </div>
    );
};

export default DateInput;
